import {Injectable, signal} from '@angular/core';

/**
 * Der Schalter "Schlagzeile erzeugen" der Leiste oben im Reiter "Nacht" (Oktober 2026).
 *
 * Standardmäßig aus. Steht er an, erzeugt der Knopf "KI-Texte erzeugen" dieses Reiters –
 * wie im Reiter "Heute" – neben dem Nacht-Text eine zweite Anfrage für die Schlagzeile, in
 * dieselbe Schlagzeilen-Textbox, nur aus den Nacht-Daten (den Karten des Nacht-Reiters).
 *
 * Zustand je Nacht-Textbox (`zielId`, z.B. `wdr.kitexte.nacht` bzw. die Nacht-Box einer
 * Lokalzeit-Stadt), nur für die Sitzung – wie die grünen Boxen nicht im Datensatz. Ein
 * Signal, weil die Leiste den Schalter zeigt und die Detail-Komponente ihn aus einem
 * Bus-Callback liest.
 */
@Injectable({providedIn: 'root'})
export class SchlagzeileSchalterService {

  private readonly an = signal<ReadonlySet<string>>(new Set());

  /** Steht der Schalter für diese Nacht-Textbox an? */
  istAn(zielId: string | null | undefined): boolean {
    return !!zielId && this.an().has(zielId);
  }

  /** Legt den Schalter dieser Nacht-Textbox um. */
  umschalten(zielId: string): void {
    const neu = new Set(this.an());
    if (!neu.delete(zielId)) {
      neu.add(zielId);
    }
    this.an.set(neu);
  }

  /** Alle Schalter aus – beim Laden eines anderen Datensatzes. */
  leeren(): void {
    this.an.set(new Set());
  }
}
